export default "__VITE_ASSET__a174b474__"